import React, { FC } from 'react'
import { Box, Stack, Theme, Typography } from '@mui/material'
import ButtonComponent from './ButtonComponent'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'

type Props = {
  link: string
}

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    color: 'var(--customMainColor)',
  },
}))

const NoPageConnectedComponent: FC<Props> = (props) => {
  const history = useHistory()
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 'auto' }} alignItems={{ xs: 'center' }}>
      <Stack
        direction='row'
        spacing={{ xs: 2, md: 4 }}
        justifyContent={{ xs: 'center', sm: 'flex-start' }}
        flexWrap='wrap'
      >
        <div className={classes.item}>
          <Typography>{t('coreDashboard:noConnection')}</Typography>
        </div>

      </Stack>
      <Box marginLeft={{ sm: 'auto' }}>
        <ButtonComponent color='primary' text={t('coreDashboard:connectNow')} onClick={() => history.push(props.link)} />
      </Box>
    </Stack>
  )
}

export default NoPageConnectedComponent
